import { useState, useCallback } from 'react';
import { refetchTokens } from '../utils/refetchTokens';

export const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const useHttp = (relativeUrl = '') => {
    const [data, setData] = useState(null);
    const [dialogStatus, setDialogStatus] = useState('closed');
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const request = useCallback(async (options = {}, callback) => {
        setError(null);
        setIsLoading(true);

        try {
            let token = localStorage.getItem('token');
            const getOptions = (t) => ({
                headers: { 'Authorization': `Bearer ${t}`, 'Content-Type': 'application/json' },
                ...options
            });


            const url = `${BASE_URL}/${relativeUrl}${options.addUrl || ''}`;

            let response = await fetch(url, getOptions(token));

            if (response.status === 401) {
                await refetchTokens();
                token = localStorage.getItem('token');

                response = await fetch(url, getOptions(token));
            }

            if (!response.ok) {
                let errorData = {};
                try {
                    errorData = await response.json();
                } catch (_) {}

                const requestError = new Error(
                    errorData?.message || `HTTP ${response.status} ${response.statusText || 'Request failed'}`
                );
                requestError.status = response.status;
                requestError.data = errorData;
                throw requestError;
            }

            if (options.skipSetData) return;

            const responseData = await response.json();

            if (responseData.data?.hasOpenDialog !== undefined) {
                if (responseData.data?.hasOpenDialog) {
                    localStorage.setItem('dialogStatus', 'active');
                    setDialogStatus('active')
                } else {
                    localStorage.setItem('dialogStatus', 'closed');
                    setDialogStatus('closed')
                }
            }

            setData(responseData || {});

            if (callback) callback(responseData);

            return responseData;
        } catch (err) {
            setError(err);
        } finally {
            setIsLoading(false);
        }
    }, [relativeUrl]);


    return [data, request, error, isLoading, setData, dialogStatus];
};

export default useHttp;
